import { Rocket, ListPlus, Flame, Crown, Waves, BadgeCheck, Activity } from "lucide-react";

/** Known messaging/emoji glyphs previously baked into activity strings. */
const ACTIVITY_EMOJI_RE = /[🆕🚀🔥👑🐳🏆✓]/gu;

const KIND_META = {
  contribution: { Icon: Rocket, className: "text-zinc-300", label: "Backed" },
  new_entity: { Icon: ListPlus, className: "text-zinc-400", label: "Listed" },
  flip: { Icon: Flame, className: "text-gold", label: "Flip" },
  new_number_one: { Icon: Crown, className: "text-gold", label: "Number one" },
  whale: { Icon: Waves, className: "text-sky-400", label: "Whale" },
  verified: { Icon: BadgeCheck, className: "text-zinc-400", label: "Verified" },
};

/**
 * Strip legacy emoji from activity copy so icons stay the only visual cue.
 * Keeps historical DB rows readable once the FE owns iconography.
 */
export function stripActivityEmoji(text) {
  if (!text) return "";
  return String(text)
    .replace(ACTIVITY_EMOJI_RE, "")
    .replace(/\s{2,}/g, " ")
    .trim();
}

export function activityKindLabel(kind) {
  return (KIND_META[kind] || {}).label || "Activity";
}

/**
 * Mono-stroke icon for an activity kind. Decorative beside event copy
 * (aria-hidden); title remains for hover / sighted context.
 */
export default function ActivityKindIcon({ kind, className = "h-3.5 w-3.5", strokeWidth = 1.75 }) {
  const meta = KIND_META[kind] || { Icon: Activity, className: "text-zinc-500", label: "Activity" };
  const { Icon, className: tone, label } = meta;
  return (
    <span className={`inline-flex shrink-0 ${tone}`} title={label} aria-hidden="true">
      <Icon className={className} strokeWidth={strokeWidth} />
    </span>
  );
}
